import request from "@/utils/request";

export default function agengRetrySetSocketNum(data) {
    return request({
        url: `/device/agentSocketManage/agentRetrySetTwoWaySocket`,

        method: 'post', data
    })
}
